import axios from 'axios'
import localforage from 'localforage'
import router from '@/router'
import store from '@/store'
import { bus } from '@/plugins/event-bus'
import baseUrl from '@utils/base-url'
import appsignal from '@utils/signal'
import { formatErrors } from '@utils/errors-alert'
import subdomain from '@/utils/subdomain'
import { logout } from '@utils/auth'

const http = axios.create({
  baseURL: baseUrl
})

const intercepRequest = async (config) => {
  const token = await localforage.getItem('token')
  config.headers.common['Authorization'] = token
  bus.$emit('before-request')
  return config
}

const intercepRequestError = (error) => {
  bus.$emit('request-error')
  return Promise.reject(error)
}

const intercepResponse = (response) => {
  bus.$emit('after-response')
  return response
}

const intercepResponseError = (error) => {
  console.log('intercepResponseError - error: ', error)
  console.log('intercepResponseError - error.response.data: ', error.response.data)
  console.log('intercepResponseError - error.response: ', error.response)
  let requestTags = {}
  let actionName = `${router.app._route.name} (${router.app._route.fullPath})`

  if (error.message === 'Network Error') {
    bus.$emit('display-alert', {
      type: 'error',
      message: 'Um erro ocorreu ao entrar em contato com o servidor. Tente novamente.'
    })
  }

  bus.$emit('response-error')

  if (error.response != null) {
    if (error.response.status === 401) {
      logout()
    }
    if (error.response.status === 403) {
      bus.$emit('display-alert', {
        type: 'error',
        message: 'Você não tem permissão para acessar essa página'
      })

      router.push({ name: 'dashboard.index' })
    }
    if (error.response.status === 422) {
      if (error.response.data) {
        bus.$emit('display-alert', {
          type: 'error',
          message: formatErrors(error.response.data)
        })
      }

      error.response.data.text().then((data) => {
        bus.$emit('display-alert', {
          type: 'error',
          message: formatErrors(JSON.parse(data))
        })
      })

      error.response.then((data) => {
        console.log('intercepResponseError - data: ', data)
        bus.$emit('display-alert', {
          type: 'error',
          message: formatErrors(data)
        })
      })
    }
    if (error.response.status === 503) {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
    }

    requestTags['status'] = error.response.status
    requestTags['data'] = error.response.data
  }

  if (error.config) {
    actionName = `${router.app._route.name} (${router.app._route.fullPath}): ${error.config.method} ${error.config.url}`
    requestTags['url'] = error.config.url
    requestTags['method'] = error.config.method
    requestTags['payload'] = error.config.params
  }

  appsignal.sendError(error, (span) => {
    span.setAction(actionName)
    span.setNamespace('creditcorp-api')
    span.setTags({
      userId: store.state.profile.current.id,
      userEmail: store.state.profile.current.email,
      routeFullPath: router.app._route.fullPath,
      routeName: router.app._route.name,
      tenant: subdomain,
      ...requestTags
    })
  })
  return Promise.reject(error)
}

http.interceptors.request.use(intercepRequest, intercepRequestError)
http.interceptors.response.use(intercepResponse, intercepResponseError)

export default http



// WEBPACK FOOTER //
// ./src/services/http.js